<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
<!--                <base-input v-model="username" alternative-->
<!--                            class="mb-3"-->
<!--                            v-mask="'#######-#'"-->
<!--                            placeholder="Número de inscrição"-->
<!--                            addon-left-icon="ni ni-single-02">-->
<!--                </base-input>-->
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '1234567-8',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

const encryptedText = this.CryptoJS.AES.encrypt("Hi There!",  'secret key 123').toString()
const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto)=>{
        return this.CryptoJS.AES.encrypt(texto,  'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto)=>{
        return this.CryptoJS.AES.decrypt(texto,'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf,num_cand)=>{

        let candidato = {CPF:cpf,NUMEROINSC:num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-','')*7919;
        codigo_meio=codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0,5))*parseInt(candidato.NUMEROINSC.replace('-',''))*13 + '_'
        + String.fromCharCode(65 + parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[1]))
        + String.fromCharCode(parseInt(codigo_meio[4]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[7]%2===0? 97 : 67)+ parseInt(codigo_meio[7]))
        + '-'
        + String.fromCharCode(parseInt(codigo_meio[0]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))
        + String.fromCharCode(parseInt(codigo_meio[5]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[8]))
        + '_'
        + String.fromCharCode(parseInt(codigo_meio[2]%2===0? 97 : 67)+ parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[6]))
        + String.fromCharCode(parseInt(codigo_meio[6]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))

        return codigo_arquivo+'.pdf';
      }


      let cands =

[{"num_cand":"U2FsdGVkX1/GFFWousGGcGUjlrArgtndcM5u3MmZXUM=","cpf":"U2FsdGVkX1+wQoFjLt47QBsmkwBPlCLdB9cgp4owQyY="},{"num_cand":"U2FsdGVkX18VRa0yAhe0gjCQgVftnXRefDJbxYKyuUc=","cpf":"U2FsdGVkX19/Vq2djgjcebiAnafLoIlYZJteti32jHs="},{"num_cand":"U2FsdGVkX1/03RoH3EXBRrAJg7bIheSHzWaQ+RW5t80=","cpf":"U2FsdGVkX1/CTh+eptWXg8UMlwrANtVasRMW5SwVcY0="},{"num_cand":"U2FsdGVkX18oeI+kPnDaj9AvAa/RF3h/n8qB4hJjudM=","cpf":"U2FsdGVkX19lR2Uyiwd21LWQqpjb2XZgHCsSg0c4b9w="},{"num_cand":"U2FsdGVkX18ue6JiQ4flo+pcshJ08w6QIjIDiIewDJw=","cpf":"U2FsdGVkX1+uu6RP2qvRiJKoS3Veqt732rNFPGCtaO0="},{"num_cand":"U2FsdGVkX1/3lJpLmtogOuZxJKC1zkkfnt91V7+qguE=","cpf":"U2FsdGVkX18WkauQeW7NCCUOmjTz4k3jSzrTkhmoKjs="},{"num_cand":"U2FsdGVkX1+fAB6CClfdKYsQLwY3kHszRL7PxId1+QU=","cpf":"U2FsdGVkX1+9GgEEcF1tyed8gXFQq1xX4g24F8AlmvE="},{"num_cand":"U2FsdGVkX1+/YKpX5UH3EnbOBue8FIHBhjADxHecreE=","cpf":"U2FsdGVkX18YgUXnol0g9ebutPrlcVsDvSoM7VRU93I="},{"num_cand":"U2FsdGVkX1+m9qGQj9dy0twLLSXr2ehH2muJKHNAp0w=","cpf":"U2FsdGVkX1/mH4jarbxKzPMaNS/BXMhUd0Yy646oUUc="},{"num_cand":"U2FsdGVkX18Jjclu8Hc6jw+yxV7lqzgxYzXTBHv9Kpw=","cpf":"U2FsdGVkX1/8uvDXpebagKEcY9u0WY2BlvSI5wng50g="},{"num_cand":"U2FsdGVkX1+nu0sHwPIVQEDW8m8PisK6wwBfOBKWU1E=","cpf":"U2FsdGVkX1+WxKT0JO1guvcQ5wTJ0XkxXE4szOp0fXI="},{"num_cand":"U2FsdGVkX1+kjKRhALLzO8NTQvHmFSuIALXLflR7ZR4=","cpf":"U2FsdGVkX190KKaCQy7SJtZsGHJ/GYo5n3/jG1GAM8w="},{"num_cand":"U2FsdGVkX19JegNvpABNFAzFhJXLG73pClUj5yJH4zw=","cpf":"U2FsdGVkX19p1CM5QssM++AH5ZC2JcyMiK/G56I1ZGE="},{"num_cand":"U2FsdGVkX19E1hYpID6H3GzJVX3/RY/zMgdc80JTmyo=","cpf":"U2FsdGVkX19MDLc3kTM2qpKDwj+wPabQRNfSsmkZmsw="},{"num_cand":"U2FsdGVkX1/OwYplfdySLxlvep38LdzmsRdi1ARbUTg=","cpf":"U2FsdGVkX19kb9vRbDEYvaqx/Ba8v4SA6Buxo/LjotY="},{"num_cand":"U2FsdGVkX1/FIJa4P86Eupgq6lEJwGAyeAQL4JT11zA=","cpf":"U2FsdGVkX18NpmjkZO5moW746sjOVnMiUMXI6czQMls="},{"num_cand":"U2FsdGVkX19SXemufQqbhQwe9Qz632v5Gjn0/puHQsY=","cpf":"U2FsdGVkX18ZeGvvfmnPrh0RD6ODUCbQhVni1skersM="},{"num_cand":"U2FsdGVkX181gVHJ5Rxyj4Amt/Voo80EINvyp1ec87M=","cpf":"U2FsdGVkX1/rJhybhcWc7YeL6ZX4IERfbtsx9QSHxBk="},{"num_cand":"U2FsdGVkX18nD4ZQg4G1ZXd2aXlr8KEJDRJhdsghRGM=","cpf":"U2FsdGVkX1802ur9D0Hk6e51o6W24aCvqdVipCOZ5Zc="},{"num_cand":"U2FsdGVkX1/Ji5wJQmM9LRoWGXOSTQxZ6p1LGx/gjPs=","cpf":"U2FsdGVkX1/OGWVRrzks+M99LbQYVoB9IbGMEqhDESM="},{"num_cand":"U2FsdGVkX1/Yv/EhLOHzeOHZwOETo+f2nmHRD3amHMk=","cpf":"U2FsdGVkX1+lRIJjH2OnCSzM+KLJSpx5rTd6DANPz6w="},{"num_cand":"U2FsdGVkX1+VS0rrJ5oYr+cCOQoeD5fnLU4CjKcU/AE=","cpf":"U2FsdGVkX18xa2h6QbeLVdx5UpvJEYiFpw5mrG1hazk="},{"num_cand":"U2FsdGVkX1+Z9+3FqlAwhbn2dbpz84S+pFWAzawqWA0=","cpf":"U2FsdGVkX18OMch2AxveMu5cJhEHfZKMlxcWc57zE1E="},{"num_cand":"U2FsdGVkX1/vu1g09Cm7k9ntKZqCTPj4/iPak/dWWwg=","cpf":"U2FsdGVkX1+OyR38AvvGQbTAxUx7wsQ0c8dHBuPiH6o="},{"num_cand":"U2FsdGVkX18gcIXYITbFXWySGHpRhogMqA1FfBsLPlg=","cpf":"U2FsdGVkX1+TwkHKjMMZmFdWbaKeTtkmYfrdvdyLngk="},{"num_cand":"U2FsdGVkX18XZdoCtyAldMBcinGjG1y/T16XOjz2XlI=","cpf":"U2FsdGVkX18aUorEnhL608ggbi2qZZh8DhuTLMM0hLg="},{"num_cand":"U2FsdGVkX1/G4fc5RMJYDYtgICm3wYp5zdqLtmfah60=","cpf":"U2FsdGVkX18OOr83eRqTH2PMo6oPSb6XcifocZnpdvg="},{"num_cand":"U2FsdGVkX1/kNAs7f6fBcWh5rJmBO5lOfdnJ93mqWYE=","cpf":"U2FsdGVkX18D+wXB9ksp/tdv044jdIbTWbI/cxISwKo="},{"num_cand":"U2FsdGVkX1/omq+61v8AiPAHIg7KhbK1D4YV7VqW6LI=","cpf":"U2FsdGVkX18QCpBuT6rWODEUSIsaver4Km4e7IOvWWA="},{"num_cand":"U2FsdGVkX19Eg2txIqXzUMaHyYy2ujCEa+61k/A1+p4=","cpf":"U2FsdGVkX18BSbQoP1lfuEqA8N6C+MzE3A8bjclpFpA="},{"num_cand":"U2FsdGVkX1/Boyvjv8HWMWjk6Q3Q8dVXUMoptEjcOVE=","cpf":"U2FsdGVkX19ylwkl716xZv43fvIDGX7KGJ1+GnoWGGM="},{"num_cand":"U2FsdGVkX1+xPRPKusFMu9518szRKA/uf5b0RGA75NU=","cpf":"U2FsdGVkX18Pt3XzDK/OYW+rTd7l/f00Yedlq5QimcM="},{"num_cand":"U2FsdGVkX1+KwVk60A+0o8rjhIBwP/oMYM1DcfzNpE8=","cpf":"U2FsdGVkX18gzBHyeQuTwRT7UYCw3lsp5A9eJRkSO1I="},{"num_cand":"U2FsdGVkX19uWzzov1T3q5ZTrH5FmvrfVQs+mWQUFpE=","cpf":"U2FsdGVkX1/EOjbXU6kyFMuKaKJZOrlZm/DLrOqanOo="},{"num_cand":"U2FsdGVkX19uhdnQQClfE+Ha/t3ymhZ8Ny9KIqJ8/gg=","cpf":"U2FsdGVkX18ishA9yKNjG854DmExxdzUQBo58BzhnMQ="},{"num_cand":"U2FsdGVkX18iXL+Dv0N4k70/dWaI5LLbGZrdi7SAQIw=","cpf":"U2FsdGVkX1/y3+oXplU7bwEz0S2a6eMtQkEM4LSEbGg="},{"num_cand":"U2FsdGVkX19PuZQcCGkkHccrRJFFOsJP3nipewjmRlM=","cpf":"U2FsdGVkX19eMqN3h5o7e/C5cWrceZbffpM60snZUF0="},{"num_cand":"U2FsdGVkX19i0YavnfYdoJrku+KtonDtYNgXs808Oxc=","cpf":"U2FsdGVkX18DGQ1vJLXZT2VWQ5xM/VVg5/3I9YXdEBs="},{"num_cand":"U2FsdGVkX19tLNoPAjswi/qUwOFbGkuIhIMhLJY7IHg=","cpf":"U2FsdGVkX19fGelF1tGpAIYDGNxEM931+dTy3by/GQU="},{"num_cand":"U2FsdGVkX1/WWz5BWZwzRJfajpqUqMpdyHp+/CZhkj0=","cpf":"U2FsdGVkX18fWb4H03BenKwUykP+XqdWfKyfosk+bOI="},{"num_cand":"U2FsdGVkX1/UM5Hn6duUcZIzTMi3W7+gPGm0AN71ZgY=","cpf":"U2FsdGVkX18vv3s7hJq7RWC2iLaTimaeMrCCyERWCiU="},{"num_cand":"U2FsdGVkX1+ZVjk/j6YaJz4DeSVNlUN4qBxIoOIL3b4=","cpf":"U2FsdGVkX1+8TC0CQ/Tsrlj1F1/xwNOLuZ5Lk+5QzOE="},{"num_cand":"U2FsdGVkX1/c+uXe5l8y1xUgwLVKFUVY0z4STxropY0=","cpf":"U2FsdGVkX19T4PG6vkEdzf60VS41yusuIszXe8TWFvg="},{"num_cand":"U2FsdGVkX1/JUbW6g6LyOxcltC/X/vNsdYrBgqcitE0=","cpf":"U2FsdGVkX1+RwNdJlPW3I1N7h5GCZpfTX4NRJ9klD0E="}]
      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
            let num_cand_decripted = decrypt(login.num_cand);
            let cpf_decripted = decrypt(login.cpf);

            // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
             let nome_arquivo = (gera_file_name(cpf_decripted,num_cand_decripted))
              nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
              let url = (`https://fs.ibfc.org.br/arquivos/2228/impuganacao/${nome_arquivo}`)
              return window.location = url;          }


        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
